var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 8.88889H22.2222V13.3333H17.7778V8.88889Z",
    fill: "#1F1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 26.6667H22.2222V31.1111H17.7778V26.6667Z",
    fill: "#1F1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 13.3333H22.2222V17.7778H17.7778V13.3333Z",
    fill: "#1F1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 31.1111H22.2222V35.5556H17.7778V31.1111Z",
    fill: "#1F1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 35.5556H22.2222V40H17.7778V35.5556Z",
    fill: "#1F1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 17.7778H22.2222V22.2222H17.7778V17.7778Z",
    fill: "#1F1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 22.2222H22.2222V26.6667H17.7778V22.2222Z",
    fill: "#1F1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 0H13.3333V4.44444H8.88889V0Z",
    fill: "#1F1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 4.44444H13.3333V8.88889H8.88889V4.44444Z",
    fill: "#1F1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 4.44444H8.88889V8.88889H4.44444V4.44444Z",
    fill: "#1F1E1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 8.88889H8.88889V13.3333H4.44444V8.88889Z",
    fill: "#1F1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 8.88889H13.3333V13.3333H8.88889V8.88889Z",
    fill: "#1F1E1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.88889H17.7778V13.3333H13.3333V8.88889Z",
    fill: "#1F1E1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.88889H4.44444V13.3333H0V8.88889Z",
    fill: "#1F1E1E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 13.3333H8.88889V17.7778H4.44444V13.3333Z",
    fill: "#1F1E1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 13.3333H13.3333V17.7778H8.88889V13.3333Z",
    fill: "#1F1E1E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3333H17.7778V17.7778H13.3333V13.3333Z",
    fill: "#1F1E1E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 26.6667H17.7778V31.1111H13.3333V26.6667Z",
    fill: "#1F1E1E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3333H4.44444V17.7778H0V13.3333Z",
    fill: "#1F1E1E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 17.7778H8.88889V22.2222H4.44444V17.7778Z",
    fill: "#1F1E1E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 17.7778H13.3333V22.2222H8.88889V17.7778Z",
    fill: "#1F1E1E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.7778H17.7778V22.2222H13.3333V17.7778Z",
    fill: "#1F1E1E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 31.1111H17.7778V35.5556H13.3333V31.1111Z",
    fill: "#1F1E1E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.7778H4.44444V22.2222H0V17.7778Z",
    fill: "#1F1E1E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 22.2222H8.88889V26.6667H4.44444V22.2222Z",
    fill: "#1F1E1E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 22.2222H13.3333V26.6667H8.88889V22.2222Z",
    fill: "#1F1E1E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 22.2222H17.7778V26.6667H13.3333V22.2222Z",
    fill: "#1F1E1E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 26.6667H13.3333V31.1111H8.88889V26.6667Z",
    fill: "#1F1E1E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.44444H17.7778V8.88889H13.3333V4.44444Z",
    fill: "#1F1E1E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 0H26.6667V4.44444H31.1111V0Z",
    fill: "#1F1E1E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 4.44444H26.6667V8.88889H31.1111V4.44444Z",
    fill: "#1F1E1E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 4.44444H31.1111V8.88889H35.5556V4.44444Z",
    fill: "#1F1E1E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 8.88889H31.1111V13.3333H35.5556V8.88889Z",
    fill: "#1F1E1E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 8.88889H26.6667V13.3333H31.1111V8.88889Z",
    fill: "#1F1E1E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 8.88889H22.2222V13.3333H26.6667V8.88889Z",
    fill: "#1F1E1E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.88889H35.5556V13.3333H40V8.88889Z",
    fill: "#1F1E1E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 13.3333H31.1111V17.7778H35.5556V13.3333Z",
    fill: "#1F1E1E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 13.3333H26.6667V17.7778H31.1111V13.3333Z",
    fill: "#1F1E1E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 13.3333H22.2222V17.7778H26.6667V13.3333Z",
    fill: "#1F1E1E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 26.6667H22.2222V31.1111H26.6667V26.6667Z",
    fill: "#1F1E1E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13.3333H35.5556V17.7778H40V13.3333Z",
    fill: "#1F1E1E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 17.7778H31.1111V22.2222H35.5556V17.7778Z",
    fill: "#1F1E1E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 17.7778H26.6667V22.2222H31.1111V17.7778Z",
    fill: "#1F1E1E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 17.7778H22.2222V22.2222H26.6667V17.7778Z",
    fill: "#1F1E1E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 31.1111H22.2222V35.5556H26.6667V31.1111Z",
    fill: "#1F1E1E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17.7778H35.5556V22.2222H40V17.7778Z",
    fill: "#1F1E1E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 22.2222H31.1111V26.6667H35.5556V22.2222Z",
    fill: "#1F1E1E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 22.2222H26.6667V26.6667H31.1111V22.2222Z",
    fill: "#1F1E1E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 22.2222H22.2222V26.6667H26.6667V22.2222Z",
    fill: "#1F1E1E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 26.6667H26.6667V31.1111H31.1111V26.6667Z",
    fill: "#1F1E1E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 4.44444H22.2222V8.88889H26.6667V4.44444Z",
    fill: "#1F1E1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.2b1718703f739b37e1187d802725c286.svg";
export { ForwardRef as ReactComponent };